module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('ul', {
    staticClass: "nav navbar-nav flex-row float-right nav-icon text-center",
    attrs: {
      "id": "HeaderRightMenuList"
    }
  }, [_c('li', {
    staticClass: "nav-item nav-item-contact",
    style: ({
      height: _vm.headerHeight + 'px',
      width: _vm.iconWidth + 'px'
    })
  }, [_c('a', {
    staticClass: "nav-link nav-icon",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope",
    class: _vm.iconSizeClass,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][7]"
    }
  })], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item nav-item-menu",
    style: ({
      height: _vm.headerHeight + 'px',
      width: _vm.iconWidth + 'px'
    })
  }, [_c('a', {
    staticClass: "nav-link nav-icon",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    class: _vm.iconSizeClass,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][8]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right py-1"
  }, [_c('div', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][12]"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][15]"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][13]"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][14]",
      "adjustLangFontSizes": {
        en: 0.8
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][17]"
    }
  })], 1), _vm._v(" "), (_vm.isLoggedInPage) ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[12][1]"
    }
  })], 1) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ffef8f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/partials/HeaderRightMenuPC.vue
// module id = 677
// module chunks = 0